import { render, staticRenderFns } from "./ChildrenLotsModal.vue?vue&type=template&id=68b6b6eb"
import script from "./ChildrenLotsModal.vue?vue&type=script&lang=js"
export * from "./ChildrenLotsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports